import { API } from '../constants/constants';

export const getMonthlyInteractions = async (
  month: string,
  timezoneOffset: string,
  isCalendarEvent: boolean = false,
  includeDetails: boolean = false
) => {
  const res = await API.get(`/issues/monthly`, {
    params: {
      month,
      timezoneOffset,
      isCalendarEvent,
      includeDetails,
    },
  });
  return res.data;
};

export const createInteraction = async (data: any) => {
  const res = await API.post(`/issue`, data);
  return res.data;
};

export const updateInteractionWithFiles = async (data: any) => {
  const { id, fields, uploadingUrls, removingUrls } = data;
  const res = await API.put(`/issues/${id}/update`, {
    urls: uploadingUrls,
    deletingUrls: removingUrls,
    fields,
  });

  return res.data;
};

export const deleteInteraction = async (id: string) => {
  const res = await API.delete(`/issue/${id}`);
  return res.data;
};

export const getFilteredInteractions = async (filterQueryString: string, isCalendarEvent: boolean = false) => {
  const calendarQueryString = isCalendarEvent ? `${filterQueryString}&isCalendarEvent=true` : filterQueryString;
  const res = await API.get(`issues/filter?${calendarQueryString}`);
  return res.data?.data;
};

export const getCalendarFilteredInteractions = async (
  filterQueryString: string,
  month: string,
  timezoneOffset: string,
  isCalendarEvent: boolean = false
) => {
  const res = await API.get('/issues/calendarFilter', {
    params: {
      ...Object.fromEntries(new URLSearchParams(filterQueryString)),
      month,
      timezoneOffset,
      isCalendarEvent,
    },
  });
  return res.data?.data;
};

export const getFuzzySearchInteractions = async (queryString: string | undefined, category: string | undefined) => {
  const res = await API.get(`/issues/fuzzySearch`, {
    params: {
      queryString,
      category,
    },
  });
  return res.data?.data;
};

export const getInteractionDetail = async (id: string) => {
  const res = await API.get(`/issue/${id}/flat`);
  return res.data?.data;
};

export const getCalendarQuickSearchInteractions = async ({
  queryString,
  category,
}: {
  queryString: string;
  category: string;
}) => {
  const res = await API.get('/issues/calendarQuickSearch', {
    params: {
      queryString,
      category,
    },
  });
  return res.data?.data;
};
